import { Link } from "react-router-dom";
import { ShieldAlert, ArrowUpRight } from "lucide-react";
import { FOOTER_BAR_TEXT } from "../lib/disclaimer";

/**
 * Thin always-visible disclaimer bar above the main footer. Stays in the
 * normal document flow (not fixed) so it never overlaps content. Includes a
 * link to the full public disclaimer page so the legal text is always one
 * click away.
 */
export default function DisclaimerFooterBar() {
  return (
    <div
      data-testid="disclaimer-footer-bar"
      role="contentinfo"
      className="w-full border-t border-amber-500/30 bg-amber-500/[0.06] text-amber-200/85 text-[11px] sm:text-xs px-4 sm:px-6 py-2.5"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 leading-snug">
        <div className="flex items-start sm:items-center gap-2">
          <ShieldAlert size={12} className="text-amber-400 shrink-0 mt-0.5 sm:mt-0" />
          <span>{FOOTER_BAR_TEXT}</span>
        </div>
        <Link
          to="/legal/disclaimer"
          data-testid="disclaimer-footer-bar-link"
          className="inline-flex items-center gap-1 text-amber-300 hover:text-amber-100 hover:underline underline-offset-2 shrink-0"
        >
          Read full disclaimer <ArrowUpRight size={11} />
        </Link>
      </div>
    </div>
  );
}
